var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdaptiveCruise32 = function SvgAdaptiveCruise32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.86 12h2.28c1.023 0 2.005.398 2.73 1.107A3.74 3.74 0 0 1 21 15.78v11.045c0 .842-.342 1.65-.95 2.245a3.278 3.278 0 0 1-2.293.93h-3.514c-.86 0-1.685-.334-2.293-.93a3.141 3.141 0 0 1-.95-2.245V15.78c0-.496.1-.988.294-1.446.194-.459.478-.876.837-1.227A3.883 3.883 0 0 1 14.861 12Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.719 17h2.552c.99 0 1.938.391 2.637 1.088A3.706 3.706 0 0 1 21 20.713v4.274A1.019 1.019 0 0 1 19.983 26h-7.966A1.019 1.019 0 0 1 11 24.987v-4.3a3.705 3.705 0 0 1 1.098-2.605A3.736 3.736 0 0 1 14.718 17v0ZM11 20H9m14 0h-2M10 5l1.393-1.248a6.728 6.728 0 0 1 2.155-1.297A6.81 6.81 0 0 1 16 2c.873 0 1.828.155 2.634.455a6.73 6.73 0 0 1 2.155 1.297L22 5m-9 3 .695-.837C14.318 6.418 15.12 6 16 6c.88 0 1.768.418 2.39 1.163L19 8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAdaptiveCruise32;